import React, { useEffect, useState, useMemo } from "react";
import Loader from "../../../../Loader/Loader";
import DashboardMenu from "../../../layout/dashboardMenu";
import Header from "../../../layout/header";
import { toast } from "react-toastify";
import SuccessModal from "../../../CustomModal/Success";
import FailedModal from "../../../CustomModal/Failed";
import $ from "jquery";

const ChangeAssignee = ({
  fetchAssignee,
  getAssignee = [],
  history,
  fetchDealerListing,
  getDealerListingForAssignee = [],
  dealerManagerReassign,
  reassignDealerWithManager = [],
}) => {
  const [isLoading, setIsLoading] = useState(false);
  const [accountIds, setAccountIds] = useState([]);
  const [assignedTo, setAssignedTo] = useState("");
  const [countToOpenModal, setCountToOpenModal] = useState(0);
  const [isSuccessModalOpen, setIsSuccessModalOpen] = React.useState(false);
  const [isFailedModalOpen, setIsFailedModalOpen] = React.useState(false);
  const [isAllChecked, setIsAllChecked] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");

  useEffect(() => {
    (async () => {
      setIsLoading(true);
      await fetchAssignee();
      await fetchDealerListing();
      setIsLoading(false);
    })();
  }, []);

  const filteredDealers = useMemo(() => {
    return (
      getDealerListingForAssignee?.data?.filter(
        (val) =>
          val?.company_legal_name &&
          val.company_legal_name
            .toLowerCase()
            .includes(searchQuery.toLowerCase())
      ) || []
    );
  }, [getDealerListingForAssignee, searchQuery]);

  useEffect(() => {
    setIsFailedModalOpen(false);
    setIsSuccessModalOpen(false);
    if (reassignDealerWithManager?.status === 200) {
      setIsSuccessModalOpen(true);
    } else if (
      reassignDealerWithManager?.status !== undefined &&
      reassignDealerWithManager?.status !== 200
    ) {
      setCountToOpenModal(countToOpenModal + 1);
      setIsFailedModalOpen(true);
    }
  }, [reassignDealerWithManager]);

  const handleAddAccount = (e, id) => {
    if (e.target.checked) {
      setAccountIds((prev) => [...prev, parseInt(id)]);
    } else {
      setAccountIds((prev) =>
        prev.filter((accountId) => accountId !== parseInt(id))
      );
    }
  };

  const handleAssignee = async (e) => {
    e.preventDefault();

    if (assignedTo === "") {
      toast.error("Please select an assignee");
      return;
    }

    let finalAccountIds = [...accountIds];
    if (isAllChecked && getDealerListingForAssignee?.data) {
      finalAccountIds = getDealerListingForAssignee.data.map(
        (element) => element?.id
      );
    }

    if (finalAccountIds.length === 0) {
      toast.error("Please select accounts to assign");
      return;
    }

    const request = {
      dealer_id_list: finalAccountIds,
      managed_by: parseInt(assignedTo, 10),
    };

    setIsLoading(true);
    await dealerManagerReassign(request);
    setIsLoading(false);
  };

  const makeAllChecked = (e) => {
    if (e.target.checked) {
      setIsAllChecked(true);
      const allIds = filteredDealers.map((dealer) => dealer.id);
      setAccountIds(allIds);
    } else {
      setIsAllChecked(false);
      setAccountIds([]);
    }
  };

  return (
    <>
      <SuccessModal
        isOpen={isSuccessModalOpen}
        msg={reassignDealerWithManager?.message}
        url={"ucd-change-assignee"}
      />

      <FailedModal
        isOpen={isFailedModalOpen}
        msg={reassignDealerWithManager?.message}
      />

      <Loader isLoading={isLoading} />
      <div id="wrapper">
        <DashboardMenu />
        <div id="content-wrapper" className="d-flex flex-column">
          <div id="content">
            <Header history={history} title={"Assign Dealer"} />
            <div className="container-fluid common-bg">
              <div className="container-fluid bootstrap snippets bg-white">
                <div className="card-content">
                  {/* Heading */}
                  <div className="col-md-12 mt-1">
                    <input
                      type="text"
                      className="form-control bg-light border-0 small list-filter"
                      placeholder={"Search Dealer..."}
                      aria-label="Search"
                      aria-describedby="basic-addon2"
                      value={searchQuery}
                      onChange={(e) => setSearchQuery(e.target.value)}
                    />
                  </div>
                  {/* Select Assignee */}
                  <div
                    className="mt-1 float-field"
                    style={{ width: "90%", marginLeft: "4%" }}
                  >
                    <select
                      className="form-control form-control-user"
                      onChange={(e) => {
                        setAssignedTo(e.target.value);
                      }}
                      required
                    >
                      <option value="">Select Assignee</option>
                      {getAssignee.length > 0 &&
                        getAssignee.map((val) => {
                          return <option value={val?.id}>{val.name}</option>;
                        })}
                    </select>
                    <label className="large-label float-lb">Assignee</label>
                  </div>
                  {/* Dealer List */}
                  <div className="card-body">
                    <div className="user mt-4">
                      <div className="row notification-lists">
                        <div className="col-md-12">
                          <div className="notification-ui_dd-content noty">
                            <div
                              className=""
                              style={{ marginLeft: "85%", width: "5%" }}
                            >
                              <input
                                type="checkbox"
                                className="form-control form-control-user"
                                onClick={(e) => makeAllChecked(e)}
                                value={""}
                                id="validationCustom01"
                              />
                            </div>
                            {filteredDealers.length > 0 ? (
                              filteredDealers.map((val, i) => (
                                <div
                                  className="notification-list notification-list--unread"
                                  key={i}
                                >
                                  <div
                                    className="notification-list_content"
                                    style={{ marginTop: "6%" }}
                                  >
                                    <div className="notification-list_detail">
                                      <p className="green">
                                        <b className="title-color">
                                          {val?.company_legal_name}
                                        </b>
                                      </p>
                                      <p className="text-muted">
                                          <small><i>({"Assignee Name: " + val?.manager_name})</i></small>
                                      </p>
                                      <p className="text-muted">
                                          <small><i>({"Assignee Email: " + val?.manager_email})</i></small>
                                      </p>
                                    </div>
                                  </div>
                                  <div>
                                    <input
                                      type="checkbox"
                                      className="form-control form-control-user"
                                      style={{
                                        height: "1rem",
                                        width: "1rem",
                                      }}
                                      onChange={(e) =>
                                        handleAddAccount(e, val?.id)
                                      }
                                      checked={accountIds.includes(val?.id)}
                                    />
                                  </div>
                                </div>
                              ))
                            ) : (
                              <h4
                                className="d-flex"
                                style={{ justifyContent: "center" }}
                              >
                                No dealer found
                              </h4>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* Submit Button */}
        <div 
        className="d-flex"
        style={{position: "fixed", width:"auto", bottom: "20px", right: "20px", zIndex: "1000"}}
        >
          <button
            className="btn btn-primary"
            onClick={(e) => {
              handleAssignee(e);
            }}
          >
            Submit
          </button>
        </div>
      </div>

      {/* section ends */}
    </>
  );
};

export default ChangeAssignee;



